import angular from 'angular';

import Alpha from './Alpha';
import Approval from './Approval';
import Capitalize from './Capitalize';
import CategoryColors from './CategoryColors';
import CategoryName from './CategoryName';
import Count from './Count';
import DeliveryMethod from './DeliveryMethod';
import FileName from './FileName';
import FileSize from './FileSize';
import Instructors from './Instructors';
import MultiAudience from './MultiAudience';
import PrettyDate from './PrettyDate';
import PrettyDateOffset from './PrettyDateOffset';
import PrettyDateTime from './PrettyDateTime';
import Progress from './Progress';
import RangeDate from './RangeDate';
import SecondsToTime from './SecondsToTime';
import ToArray from './ToArray';
import ToWords from './ToWords';
import CnfTotalHours from './CnfTotalHours';
import TotalHours from './TotalHours';
import Unique from './Unique';
import { CapitalizeFirstLetter, TitleFromCamelCase, ToCamelCase } from './CamelCase';
import CycleDuration from './CycleDuration';
import IsCourse from './IsCourse';
import IsEvent from './IsEvent';
import DateRangePrettyDateTime from './DateRangePrettyDateTime';
import RegulatorBasicName from './RegulatorBasicName';
import RegulatorName from './RegulatorName';
import OrderArray from './OrderArray';
import OrderObject from './OrderObject';
import Sponsors from './Sponsors';

export default angular
  .module('app.filters', [])
  .filter('Alpha', Alpha)
  .filter('Approval', Approval)
  .filter('Capitalize', Capitalize)
  .filter('CategoryColors', CategoryColors)
  .filter('CategoryName', CategoryName)
  .filter('Count', Count)
  .filter('DeliveryMethod', DeliveryMethod)
  .filter('FileName', FileName)
  .filter('FileSize', FileSize)
  .filter('Instructors', Instructors)
  .filter('MultiAudience', MultiAudience)
  .filter('PrettyDate', PrettyDate)
  .filter('PrettyDateOffset', PrettyDateOffset)
  .filter('PrettyDateTime', PrettyDateTime)
  .filter('Progress', Progress)
  .filter('RangeDate', RangeDate)
  .filter('SecondsToTime', SecondsToTime)
  .filter('ToArray', ToArray)
  .filter('ToWords', ToWords)
  .filter('TotalHours', TotalHours)
  .filter('Unique', Unique)
  .filter('ToCamelCase', ToCamelCase)
  .filter('TitleFromCamelCase', TitleFromCamelCase)
  .filter('CapitalizeFirstLetter', CapitalizeFirstLetter)
  .filter('CycleDuration', CycleDuration)
  .filter('IsCourse', IsCourse)
  .filter('DateRangePrettyDateTime', DateRangePrettyDateTime)
  .filter('IsEvent', IsEvent)
  .filter('RegulatorBasicName', RegulatorBasicName)
  .filter('RegulatorName', RegulatorName)
  .filter('CnfTotalHours', CnfTotalHours)
  .filter('OrderArray', OrderArray)
  .filter('OrderObject', OrderObject)
  .filter('Sponsors', Sponsors).name;



// WEBPACK FOOTER //
// ./src/app/filters/index.js